import { Box } from "@mui/material";
import { EntityTemplateStandardField, EntityTemplateStep, LegalEntityStandardField } from "../../../entityTemplates/EntityTemplate.types";
import { LegalEntityFieldRenderer } from "../../../entityTemplates/LegalEntityFieldRenderers";
import StepSegment from "../../../processingActivity/stepSegment/StepSegment";
import { ValidationError } from "@common/validationError";
import { EditLegalEntityModel } from "../EditLegalEntity.types";

const largeStepSegments: Array<EntityTemplateStandardField> = [LegalEntityStandardField.LegalEntitySubContractors];

export interface LegalEntityStepProps {
    legalEntityId: string;
    isLoading: boolean;
    legalEntityTemplateStep: EntityTemplateStep;
    legalEntity: EditLegalEntityModel;
    onChange: (changeFunc: (legalEntity: EditLegalEntityModel) => void) => Promise<void>;
    onCachedChange: (changeFunc: (legalEntity: EditLegalEntityModel) => void) => void;
    onRefetchLegalEntity: () => void;
    validationErrors: Array<ValidationError>;
}

function LegalEntityStep(props: LegalEntityStepProps) {
    return (
        <>
            {[...props.legalEntityTemplateStep.fields]
                .sort((a, b) => a.order - b.order)
                .map((field) => {
                    const segmentSize = field.standardFieldIdentifier && largeStepSegments.includes(field.standardFieldIdentifier) ? "large" : "small";

                    return (
                        <StepSegment key={field.id} size={segmentSize}>
                            <Box>
                                <LegalEntityFieldRenderer
                                    isLoading={props.isLoading}
                                    field={field}
                                    isPreview={false}
                                    legalEntity={props.legalEntity}
                                    legalEntityId={props.legalEntityId}
                                    onChange={props.onChange}
                                    onCustomFieldChange={props.onCachedChange}
                                    onSubContractorsChanged={props.onRefetchLegalEntity}
                                    validationErrors={props.validationErrors}
                                />
                            </Box>
                        </StepSegment>
                    );
                })}
        </>
    );
}

export default LegalEntityStep;
